import React, { useState, useEffect } from "react";
import DataTable from "common/Tables/DataTable";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import dealerPendingRequests from "layouts/tables/data/dealerPendingRequests";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, Grid, Dialog, DialogContent, IconButton } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getPendingTimeOff, approveReuquest, rejectRequest } from "store/slice/timeoffSlice";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const PendingRequests = () => {
  const timeOffStore = useSelector((store) => store.timeoff);
  const pendingRequets = timeOffStore?.pendingRequets;
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [modalImage, setModalImage] = useState(null);

  const onApprove = (req) => {
    dispatch(approveReuquest(req));
  };

  const onReject = (req) => {
    dispatch(rejectRequest(req));
  };

  const { columns, rows } = dealerPendingRequests({
    timeOffs: pendingRequets,
    onApprove,
    onReject,
    onImageClick: (imageUrl) => setModalImage(imageUrl),
    t
  });

  useEffect(() => {
    dispatch(getPendingTimeOff());
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item size={{ xs: 12 }}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Pending Requests
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog
        open={Boolean(modalImage)}
        onClose={() => setModalImage(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            padding: 0,
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogContent
          style={{
            position: "relative",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setModalImage(null)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <CloseIcon />
          </IconButton>
          {modalImage && (
            <img
              src={modalImage}
              alt="Full Size"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "90vh",
                objectFit: "contain",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default PendingRequests;
